import styled from "styled-components";

export const Notification = styled.div`
  position: relative;

  width: 100%;

  display: flex;
  align-items: flex-start;
  gap: 10px;

  padding: 10px 20px;
`;

export const NotificationDot = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.vividBlue};
  border-radius: 50%;
  height: 8px;
  width: 8px;
  position: absolute;
  top: -2px;
  left: -2px;
`;

export const Link = styled.a`
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.primary.vividBlue};
  text-decoration: none;
`;

export const MarkAsRead = styled.span`
  cursor: pointer;
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.primary.vividBlue};
  text-decoration: none;
  font-size: 12px;
  font-weight: 700;
`;

export const Infos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  padding-top: 4px;
  cursor: pointer;

  h3 {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.primary.blue};
  }

  p {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.cinza800};
  }

  strong {
    cursor: pointer;
  }
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const TimeSince = styled.div`
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 10px;

  background-color: ${({ theme, read }) =>
    read ? theme.colors.neutral.cinza200 : `${theme.colors.primary.blue}`};

  width: fit-content;
  height: fit-content;

  span {
    white-space: nowrap;
    color: ${({ theme, read }) =>
      read ? theme.colors.neutral.cinza700 : theme.colors.neutral.white};
  }
`;
